var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_vm._v(" Copyright © 2023 西安奇点能源技术有限公司 "),_c('a',{attrs:{"href":"#"}},[_vm._v("陕ICP备20010223号-3")])])
}]

export { render, staticRenderFns }